import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollReveal } from '@/components/ui/scroll-reveal';
import iconMic from '@/assets/icon-mic.svg';
import iconMic2 from '@/assets/icon-mic2.svg';

const features = [
  {
    icon: iconMic2,
    description: "Play alongside jazz masters in real practice settings. Listen, respond, and build your voice through daily musical conversation — the way this language is actually learned.",
  },
  {
    icon: iconMic,
    description: "Work through focused practice material designed by pros. Clear guidance, musical context, and repetition that turns ideas into instinct.",
  },
];

export function InteractiveLessonsSection() {
  const navigate = useNavigate();

  return (
    <section className="pt-4 md:pt-8 lg:pt-12 px-4 sm:px-6 lg:px-8 bg-background">
      <div 
        className="max-w-6xl mx-auto px-6 sm:px-10 md:px-16 lg:px-20 py-10 sm:py-14 md:py-16 lg:py-20"
        style={{
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 45.19%, rgba(0, 0, 0, 0.05) 100%)',
          borderRadius: '140px',
        }}
      >
        {/* Feature Icons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 mb-12">
          {features.map((feature, index) => (
            <ScrollReveal key={index} delay={index * 0.15}>
              <div className="flex flex-col items-center text-center">
                <img src={feature.icon} alt="" className="w-14 h-14 md:w-20 md:h-20 mb-4" />
                <p className="text-paragraph-1 text-foreground">
                  {feature.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Headline */}
        <ScrollReveal delay={0.3}>
          <h3 className="text-headline-3 text-center text-foreground mb-8 max-w-2xl mx-auto">
            Interactive lessons, expert instruction, and{' '}
            <span className="text-[#D84632]">real-world practice</span>{' '}
            to help you grow as a jazz musician.
          </h3>
        </ScrollReveal>

        {/* CTA Button */}
        <ScrollReveal delay={0.4}>
          <div className="flex justify-center">
            <Button
              onClick={() => navigate('/library')}
              variant="outline"
              size="cta"
              className="text-button text-foreground border-foreground hover:bg-foreground/10"
            >
              VIEW ALL COURSES
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
